import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { intrinsicComponent } from './utils/functions';
export var DeleteOutline = intrinsicComponent(function (_ref, ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 14 : _ref$size,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: ref,
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M17.8571 19.6429C17.8571 18.6566 18.6566 17.8571 19.6429 17.8571C20.6291 17.8571 21.4286 18.6566 21.4286 19.6429L21.4286 37.5C21.4286 38.4862 20.6291 39.2857 19.6429 39.2857C18.6566 39.2857 17.8571 38.4862 17.8571 37.5L17.8571 19.6429Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3571 17.8571C29.3709 17.8571 28.5714 18.6566 28.5714 19.6429L28.5714 37.5C28.5714 38.4862 29.3709 39.2857 30.3571 39.2857C31.3434 39.2857 32.1429 38.4862 32.1429 37.5V19.6429C32.1429 18.6566 31.3434 17.8571 30.3571 17.8571Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2857 7.14286V3.57143C14.2857 1.59898 15.8847 0 17.8571 0H32.1429C34.1153 0 35.7143 1.59898 35.7143 3.57143V7.14286H48.2143C49.2005 7.14286 50 7.94235 50 8.92857C50 9.91479 49.2005 10.7143 48.2143 10.7143H44.6429V46.4286C44.6429 48.401 43.0439 50 41.0714 50H8.92857C6.95613 50 5.35714 48.401 5.35714 46.4286V10.7143L1.78571 10.7143C0.799491 10.7143 0 9.91479 0 8.92857C0 7.94235 0.799492 7.14286 1.78571 7.14286H14.2857ZM17.8571 3.57143H32.1429V7.14286H17.8571V3.57143ZM8.92857 10.7143L8.92857 46.4286H41.0714V10.7143H8.92857Z",
    fill: color
  }));
});
export default DeleteOutline;